"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useRef, useState } from "react";
import Input from "@/components/ui/input";
import { FilterInputProps } from "./types";

/**
 * Text filter component for free-text search.
 * Debounces input and applies on Enter or after typing stops.
 */
const TextFilter: React.FC<FilterInputProps> = t0 => {
  const $ = _c(19);
  const {
    value,
    onChange,
    label: t1,
    onBack,
    focusRef,
    onSubmit
  } = t0;
  const label = t1 === undefined ? "text" : t1;
  const [input, setInput] = useState(value || "");
  const debounceTimeoutRef = useRef(null);
  let t2;
  if ($[0] !== onChange) {
    t2 = newValue => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
      debounceTimeoutRef.current = setTimeout(() => {
        const valueToSet = newValue === "" ? undefined : newValue;
        onChange(valueToSet);
      }, 300);
    };
    $[0] = onChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const debouncedApply = t2;
  let t3;
  if ($[2] !== debouncedApply) {
    t3 = e => {
      const newValue_0 = e.target.value;
      setInput(newValue_0);
      debouncedApply(newValue_0);
    };
    $[2] = debouncedApply;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleChange = t3;
  let t4;
  if ($[4] !== input || $[5] !== onBack || $[6] !== onChange || $[7] !== onSubmit) {
    t4 = e_0 => {
      if (e_0.key === "Enter") {
        e_0.preventDefault();
        if (debounceTimeoutRef.current) {
          clearTimeout(debounceTimeoutRef.current);
        }
        const valueToSet_0 = input === "" ? undefined : input;
        onChange(valueToSet_0);
        onSubmit?.();
      } else {
        if (e_0.key === "ArrowLeft" && onBack) {
          const target = e_0.target as HTMLInputElement;
          if (target.selectionStart === 0 && target.selectionEnd === 0) {
            e_0.preventDefault();
            onBack();
          }
        }
      }
    };
    $[4] = input;
    $[5] = onBack;
    $[6] = onChange;
    $[7] = onSubmit;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleKeyDown = t4;
  let t5;
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
    };
    t6 = [];
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  React.useEffect(t5, t6);
  let t7;
  if ($[11] !== label) {
    t7 = label.toLowerCase();
    $[11] = label;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = `Search by ${t7}...`;
  let t9;
  if ($[13] !== focusRef || $[14] !== handleChange || $[15] !== handleKeyDown || $[16] !== input || $[17] !== t8) {
    t9 = <Input value={input} onChange={handleChange} onKeyDown={handleKeyDown} ref={focusRef} className="!border-none !bg-transparent !shadow-none !ring-0 focus:!border-none focus:!ring-0" placeholder={t8} autoFocus={true} />;
    $[13] = focusRef;
    $[14] = handleChange;
    $[15] = handleKeyDown;
    $[16] = input;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};
export default TextFilter;